/**
 * isExternalUser checks if the currently logged in user is a 3rd party user.
 * @param {*} profile
 * @returns {boolean}
 */
export default function isExternalUser(profile: any): any {
  if (profile && 'isExternal' in profile) {
    return profile['isExternal'];
  }

  return false;
}
